import { IMap, ITripMenuServiceObject, ITripMenuServiceState, IStoreState } from '../../../types/index'
import * as constants from '../../constants/index'
import { IServiceActions } from '../../actions/services'

const initialTripMenuServiceListState: ITripMenuServiceState = {
  items: {},
  metadata: {
    fetching: false,
    fetchingError: ''
  }
}

export function tripMenuService(
  state: ITripMenuServiceState = initialTripMenuServiceListState,
  action: IServiceActions
): ITripMenuServiceState {
  switch (action.type) {
    case constants.TRIP_MENU_SERVICE_LIST_REQUEST:
      return Object.assign({}, state, {
        metadata: {
          ...state.metadata,
          fetching: true
        }
      })
    case constants.TRIP_MENU_SERVICE_LIST_SUCCESS: {
      const items = action.payload || {}
      return Object.assign({}, state, {
        metadata: {
          ...state.metadata,
          fetching: false,
          fetchingError: ''
        },
        items: { ...items }
      })
    }
    case constants.TRIP_MENU_SERVICE_LIST_FAIL: {
      const error = action.payload
      return Object.assign({}, state, {
        metadata: {
          ...state.metadata,
          fetching: false,
          fetchingError: error
        }
      })
    }
    default:
      return state
  }
}

export const getTripMenuServiceList = (state: ITripMenuServiceState) => Object.values(state.items)



// WEBPACK FOOTER //
// ./src/state/reducers/trip-menu-services/index.ts